/*
 * @description:
 * @Author: liwg
 * @Date: 2022-06-12 10:45:07
 * @LastEditors: zhaoyu zhaoy@normstar.com
 * @LastEditTime: 2024-07-18 16:12:24
 */
import type {
  LoginAutoParams,
  LoginByPhoneParams,
  LoginParams,
  LoginResult,
  UpdatePasswordParams
} from './type'

enum Api {
  LoginByAccount = '/ns-service-app-evaluation/login/evaLogin',
  LoginByIdCard = '/ns-service-app-evaluation/login/examCardLogin',
  Logout = '/ns-service-app-evaluation/login/logout',
  LoginAuto = '/ns-service-app-evaluation/login/joinLogin',
  LoginByPhone = '/ns-service-app-evaluation/login/verifLogin',
  UpdatePassword = '/ns-service-app-user/account/updatePassword',
  SendLoginCaptcha = '/ns-service-app-user/account/sendLoginCaptcha',
  GetUserInfo = '/ns-service-support-authentication/auth/getUserInfo',
  EvaLoginByCode = '/ns-service-support-authentication/auth/evaLoginByCode',
  QueryNotice = '/ns-service-support-config/sysConfig/queryNotice'
}

export function loginByAccount(params: LoginParams) {
  return http.post<LoginResult>({
    url: Api.LoginByAccount,
    data: params
  })
}

export function loginByIdCard(params: { examCard: string }) {
  return http.post<LoginResult>({
    url: Api.LoginByIdCard,
    data: params
  })
}

export function loginByAuto(params: LoginAutoParams) {
  return http.post<LoginResult>({
    url: Api.LoginAuto,
    data: params
  })
}

export function loginByPhone(params: LoginByPhoneParams) {
  return http.post<LoginResult>({
    url: Api.LoginByPhone,
    data: params
  })
}

export function logout() {
  return http.post({
    url: Api.Logout
  })
}

export function updatePassword(params: UpdatePasswordParams) {
  return http.post({
    url: Api.UpdatePassword,
    data: params
  })
}

export function sendLoginCaptcha(params) {
  return http.post({
    url: Api.SendLoginCaptcha,
    data: params
  })
}

export function getUserInfo(params) {
  return http.post({
    url: Api.GetUserInfo,
    data: params,
    headers: {
      'Content-type': 'application/x-www-form-urlencoded;charset=UTF-8'
    }
  })
  // return new Promise((resove) => {
  //   resove({
  //     username: '测试账号',
  //     deviceId: 'ffffffff-832a-b8c3-3bcc-17030033c587',
  //     user_id: 1,
  //     access_token:
  //       'eyJhbGciOiJIUzUxMiJ9.eyJ1c2VyX2lkIjoxNDkwOTMsInVzZXJfa2V5IjoiMDFIU1daRjRZTVJNUUtUOFI0MzMzRjRGWUoiLCJ1c2VybmFtZSI6IjE1MTcyNzY1NTgwIn0.1_llWqmQvLnra1YHnb8SJeyMYk8S1b7pXB0QCfqO94LIpSY-nWlDmg2frj_QTEPBp4dY-hwO2-TGwKxLiUxsTA',
  //     url: 'com.csair.tableau.m',
  //     uuid: '74b680747bc347af8c68eaaa7f93fa2e',
  //     userInfo: {
  //       id: 1,
  //       name: '张三'
  //     }
  //   })
  // })
}

export function evaLoginByCode(params) {
  return http.post({
    url: Api.EvaLoginByCode,
    data: params,
    headers: {
      'Content-type': 'application/x-www-form-urlencoded;charset=UTF-8'
    }
  })
}

export function queryNotice() {
  return http.post(
    { url: Api.QueryNotice },
    {
      errorMessageMode: 'none'
    }
  )
}
